// extracted by mini-css-extract-plugin
export default {"cartaddremove":"iconstyle_cartaddremove__u+Bjc"};